import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  CheckboxChangeEvent,
  GrowthScoreLabelItems,
  IconType,
  LineAreaChartData,
} from '../../models/common.model';

@Component({
  selector: 'app-average-growth-metric-score-wrapper',
  templateUrl: './average-growth-metric-score-wrapper.component.html',
  styleUrls: ['./average-growth-metric-score-wrapper.component.scss'],
})
export class AverageGrowthMetricScoreWrapperComponent {
  @Input() growthScoreCardCheckbox: [];
  @Input() growthScoreCardLabel: GrowthScoreLabelItems[];
  @Input() growthMetricScoreGraph: LineAreaChartData;
  @Output() growthScoreCardCheckboxEvent = new EventEmitter<CheckboxChangeEvent>();

  svgPaths: { [key: string]: string } = {
    solidSquare: `${__webpack_public_path__}${IconType.SolidSquare}`,
    dottedCircle: `${__webpack_public_path__}${IconType.DottedCircle}`,
  };

  checkboxClicked(event: CustomEvent): void {
    this.growthScoreCardCheckboxEvent.emit(event.detail);
  }

  getSvgPath(labelIconKey: string): string {
    return this.svgPaths[labelIconKey];
  }
}
